import { SmartChargeSettingsFormModel, SmartChargeSettingsModel } from 'src/Libs/smart-charge/models'

const modelToSettingsFormTransformer = (model: SmartChargeSettingsModel): SmartChargeSettingsFormModel => ({
  emsWeatherRegulatedChargeEnabled: model.emsWeatherRegulatedChargeEnabled,
  emsStartManualCharge: 0,
  weatherCalcMode: model.weatherCalcMode,
  weatherForecastActive: model.weatherForecastActive,
  emsWeatherForecastMode: model.emsWeatherForecastMode,
})
export default modelToSettingsFormTransformer
